
import { NavigateFunction } from 'react-router-dom';

export const navigateToEnterpriseDemo = (navigate?: NavigateFunction) => {
  // Check if we're already on the enterprise page
  if (window.location.pathname === '/enterprise') {
    // If already on enterprise page, just scroll to the team section
    scrollToTeamSection();
  } else {
    // Navigate to enterprise page using React Router if available
    if (navigate) {
      navigate('/enterprise');
      // Wait for the page to render then scroll to the team section
      setTimeout(() => {
        scrollToTeamSection();
      }, 100);
    } else {
      // Fallback to window.location with hash
      window.location.href = '/enterprise#meet-the-crew';
    }
  }
};

export const navigateToEnterpriseForm = (navigate?: NavigateFunction) => {
  // Check if we're already on the enterprise page
  if (window.location.pathname === '/enterprise') {
    // If already on enterprise page, just scroll to the enterprise form section
    scrollToEnterpriseForm();
  } else {
    // Navigate to enterprise page using React Router if available
    if (navigate) {
      navigate('/enterprise');
      // Wait for the page to render then scroll to the enterprise form section
      setTimeout(() => {
        scrollToEnterpriseForm();
      }, 100);
    } else {
      // Fallback to window.location with hash
      window.location.href = '/enterprise#enterprise-form';
    }
  }
};

export const navigateToPricing = (navigate?: NavigateFunction) => {
  console.log('navigateToPricing called, current path:', window.location.pathname);
  // Check if we're already on the home page
  if (window.location.pathname === '/') {
    console.log('Already on home page, scrolling to pricing section');
    // If already on home page, just scroll to the pricing section
    scrollToPricingSection();
  } else {
    console.log('Not on home page, navigating to home and then scrolling');
    // Navigate to home page using React Router if available
    if (navigate) {
      navigate('/');
      // Wait for the page to render then scroll to the pricing section
      setTimeout(() => {
        console.log('Attempting to scroll to pricing section after navigation');
        scrollToPricingSection();
      }, 100);
    } else {
      // Fallback to window.location with hash
      window.location.href = '/#pricing';
    }
  }
};

const scrollToTeamSection = (maxAttempts = 10, currentAttempt = 0) => {
  const meetTheCrewSection = document.getElementById('meet-the-crew');
  
  if (meetTheCrewSection) {
    meetTheCrewSection.scrollIntoView({ behavior: 'smooth' });
  } else if (currentAttempt < maxAttempts) {
    // Retry after a short delay if element not found
    setTimeout(() => {
      scrollToTeamSection(maxAttempts, currentAttempt + 1);
    }, 100);
  }
};

const scrollToPricingSection = (maxAttempts = 10, currentAttempt = 0) => {
  console.log(`Attempting to scroll to pricing section (attempt ${currentAttempt + 1})`);
  const pricingSection = document.getElementById('pricing');
  
  if (pricingSection) {
    console.log('Found pricing section, scrolling to it');
    pricingSection.scrollIntoView({ behavior: 'smooth' });
  } else if (currentAttempt < maxAttempts) {
    console.log('Pricing section not found, retrying...');
    // Retry after a short delay if element not found
    setTimeout(() => {
      scrollToPricingSection(maxAttempts, currentAttempt + 1);
    }, 100);
  } else {
    console.log('Failed to find pricing section after all attempts');
  }
};

const scrollToEnterpriseForm = (maxAttempts = 10, currentAttempt = 0) => {
  const enterpriseFormSection = document.getElementById('enterprise-form');
  
  if (enterpriseFormSection) {
    enterpriseFormSection.scrollIntoView({ behavior: 'smooth' });
  } else if (currentAttempt < maxAttempts) {
    // Retry after a short delay if element not found
    setTimeout(() => {
      scrollToEnterpriseForm(maxAttempts, currentAttempt + 1);
    }, 100);
  }
};
